module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.fdb6a7e3.svg";